import React from "react";
import { X } from "lucide-react";
import { fmtCurrency } from "../lib/formatters";

// Modal listing every year with expenditures and its element breakdown.
export default function CalendarModal({ calc, onClose }) {
  if (!calc) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ background: "rgba(15,42,68,0.55)" }}
      onClick={onClose}
      data-testid="calendar-modal"
    >
      <div
        className="bg-white border-2 border-navy shadow-2xl w-[880px] max-w-[95vw] max-h-[85vh] flex flex-col rounded-[8px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-3 border-b border-rule bg-navy-wash">
          <div>
            <div className="font-display text-[17px] text-navy">Expenditure Calendar</div>
            <div className="text-[11px] text-slate">
              {calc.expenditure_calendar.length} years with spending · total{" "}
              <span className="font-mono tabular-nums text-ink">
                {fmtCurrency(calc.total_spending)}
              </span>
            </div>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-white" data-testid="calendar-close">
            <X size={18} className="text-navy" />
          </button>
        </div>
        <div className="overflow-auto flex-1">
          <table className="u-table" data-testid="calendar-table">
            <thead>
              <tr>
                <th
                  style={{
                    width: "72px",
                    position: "sticky",
                    top: 0,
                    background: "var(--u-navy-wash)",
                  }}
                >
                  Year
                </th>
                <th
                  className="text-right"
                  style={{
                    width: "120px",
                    position: "sticky",
                    top: 0,
                    background: "var(--u-navy-wash)",
                  }}
                >
                  Amount
                </th>
                <th style={{ position: "sticky", top: 0, background: "var(--u-navy-wash)" }}>
                  Elements replaced (with inflated cost)
                </th>
              </tr>
            </thead>
            <tbody>
              {calc.expenditure_calendar.map((c) => (
                <tr key={c.year} data-testid={`cal-${c.year}`}>
                  <td className="font-mono tabular-nums align-top">{c.year}</td>
                  <td className="num font-semibold align-top">{fmtCurrency(c.amount)}</td>
                  <td className="text-[12px] leading-snug" style={{ whiteSpace: "normal" }}>
                    {c.elements.map((el, i) => (
                      <span key={i}>
                        {i > 0 && <span className="text-slate"> · </span>}
                        <span>{el.name}</span>
                        <span className="text-slate font-mono tabular-nums">
                          {" "}
                          ({fmtCurrency(el.amount)})
                        </span>
                      </span>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
